var render, staticRenderFns
import script from "./sp-row.vue?vue&type=script&lang=js"
export * from "./sp-row.vue?vue&type=script&lang=js"
import style0 from "./sp-row.vue?vue&type=style&index=0&id=72f00934&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f00934",
  null
  
)

export default component.exports